import { useEffect } from 'react'
import styled from 'styled-components'

import Check from '~/shared/assets/icons/Check'
import theme from '~/shared/styles/theme'

interface Props {
  passwordInput: string
  setIsPasswordValidated: (value: boolean) => void
}

function PasswordValidationCheck({
  passwordInput,
  setIsPasswordValidated,
}: Props) {
  // 영문 1자리 이상을 포함하는지 체크하는 함수
  const containsAlphabet = (password: string) => {
    return /[a-zA-Z]/.test(password)
  }

  // 숫자 1자리 이상을 포함하는지 체크하는 함수
  const hasNumber = (password: string) => {
    return /\d/.test(password)
  }

  // 특수문자 1자리 이상을 포함하는지 체크하는 함수
  const hasSpecialCharacter = (password: string) => {
    return /[!@#$%^&*()\-_=+\\\|\[\]{};:'",.<>/?]/.test(password)
  }

  // 비밀번호 길이가 8자 이상인지 체크하는 함수
  const isValidLength = (password: string) => {
    return password.length >= 8
  }

  useEffect(() => {
    setIsPasswordValidated(
      containsAlphabet(passwordInput) &&
        hasNumber(passwordInput) &&
        hasSpecialCharacter(passwordInput) &&
        isValidLength(passwordInput),
    )
  }, [passwordInput])

  return (
    <Wrapper onClick={(e) => e.stopPropagation()}>
      <ValidationItem $isvalidate={containsAlphabet(passwordInput)}>
        <span>영문자</span>
        <Check
          color={
            containsAlphabet(passwordInput)
              ? theme.colors.mint_3
              : theme.colors.grey_3
          }
        />
      </ValidationItem>
      <ValidationItem $isvalidate={hasNumber(passwordInput)}>
        <span>숫자</span>
        <Check
          color={
            hasNumber(passwordInput) ? theme.colors.mint_3 : theme.colors.grey_3
          }
        />
      </ValidationItem>
      <ValidationItem $isvalidate={hasSpecialCharacter(passwordInput)}>
        <span>특수문자</span>
        <Check
          color={
            hasSpecialCharacter(passwordInput)
              ? theme.colors.mint_3
              : theme.colors.grey_3
          }
        />
      </ValidationItem>
      <ValidationItem $isvalidate={isValidLength(passwordInput)}>
        <span>8자 이상</span>
        <Check
          color={
            isValidLength(passwordInput)
              ? theme.colors.mint_3
              : theme.colors.grey_3
          }
        />
      </ValidationItem>
    </Wrapper>
  )
}

export default PasswordValidationCheck

const Wrapper = styled.div`
  display: flex;
  gap: 15px;
  margin-top: 12px;

  @media ${theme.device.medium} {
    gap: 5px;
  }
`

type ValidationItemProps = {
  $isvalidate: boolean
}

const ValidationItem = styled.div<ValidationItemProps>`
  display: flex;
  gap: 5px;
  align-items: center;
  width: auto;

  > span {
    width: auto;

    font-family: NanumSquareNeo-Regular, sans-serif;
    font-size: 12px;
    font-weight: 400;
    color: ${({ $isvalidate }) =>
      $isvalidate ? theme.colors.mint_3 : theme.colors.grey_3};
  }

  @media ${theme.device.medium} {
    gap: 3px;
  }
`
